import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type GoStatus = "GO" | "NEAR-GO" | "NO-GO";

/** OPT-4: small badge showing aggregate commercial GO state. */
export function GoBadge() {
  const [state, setState] = useState<GoStatus>("NO-GO");
  const [counts, setCounts] = useState({ green: 0, yellow: 0, red: 0 });

  useEffect(() => {
    (async () => {
      const { data: u } = await supabase.auth.getUser();
      if (!u.user) return;
      const { data: m } = await supabase.from("org_members")
        .select("org_id").eq("user_id", u.user.id).limit(1).maybeSingle();
      if (!m) return;
      const { data: c } = await supabase.from("commercial_go_criteria")
        .select("status").eq("org_id", m.org_id);
      const ct = { green: 0, yellow: 0, red: 0 };
      for (const r of c ?? []) {
        if (r.status === "green") ct.green++;
        else if (r.status === "yellow") ct.yellow++;
        else if (r.status === "red") ct.red++;
      }
      setCounts(ct);
      if (ct.red > 0) setState("NO-GO");
      else if (ct.yellow > 0) setState("NEAR-GO");
      else if (ct.green >= 6) setState("GO");
      else setState("NEAR-GO");
    })();
  }, []);

  const className =
    state === "GO" ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30"
    : state === "NEAR-GO" ? "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30"
    : "bg-destructive/15 text-destructive border-destructive/30";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" className={className}>
          {state}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <div className="text-xs">
          {counts.green} verdes · {counts.yellow} amarelos · {counts.red} vermelhos
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
